<template>
  <b-form-group
    label="Tanım"
    label-for="id_donation_groups"
  >
    <v-select
      id="id_donation_groups"
      v-model="filterParams.id_donation_groups"
      :options="donationGroups"
      label="title"
      :reduce="item => item.id"
      placeholder="Tümü"
      multiple
    >
      <template v-slot:selected-option="option">
        <div
          class="text-nowrap overflow-hidden"
          style="max-width: 350px;"
        >
          {{ option.title }}
          <small>
            ({{ option.main_group? option.main_group : 'Ana Grup' }})
          </small>
          <b-badge
            v-if="option.is_income === '1'"
            variant="success"
            pill
            style="padding: 3px 8px; line-height: 100% !important;"
          >
            GELİR
          </b-badge>
          <b-badge
            v-if="option.is_expense === '1'"
            variant="danger"
            pill
            style="padding: 3px 8px; line-height: 100% !important;"
          >
            GİDER
          </b-badge>
        </div>
      </template>
      <template v-slot:option="option">
        <div class="font-weight-bold">
          {{ option.title }}
        </div>
        <div class="font-small-2 text-muted">
          {{ option.main_group? option.main_group : 'Ana Grup' }}
        </div>
        <div>
          <b-badge
            v-if="option.is_income === '1'"
            variant="light-success"
            size="sm"
          >
            Gelir Grubu
          </b-badge>
          <b-badge
            v-if="option.is_expense === '1'"
            variant="light-danger"
            size="sm"
          >
            Gider Grubu
          </b-badge>
        </div>
      </template>
    </v-select>
  </b-form-group>
</template>
<script>
import vSelect from 'vue-select'
import { BFormGroup, BBadge } from 'bootstrap-vue'

export default {
  name: 'DonationGroups',
  components: {
    BFormGroup,
    BBadge,
    vSelect,
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
    donationGroups() {
      return this.$store.getters['donationGroups/dataList']
    },
  },
  created() {
    this.getDonationGroups()
  },
  methods: {
    getDonationGroups() {
      this.$store.dispatch('donationGroups/getDataList', {
        select: [
          'donation_groups.id AS id',
          'donation_groups.title AS title',
          'main_group.title AS main_group',
          'donation_groups.is_income AS is_income',
          'donation_groups.is_expense AS is_expense',
        ],
      })
    },
  },
}
</script>
